import * as Sentry from '@sentry/browser';
import { postHogCapture } from 'components/analytics/PostHog';
import Image from 'next/legacy/image';
import React from 'react';
import { BrandAware } from '../contexts/BrandContext';

const eventCapture = postHogCapture(false);

class FullPageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI

    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    eventCapture('FullPage Error Caught', { error, errorInfo });
    Sentry.captureException(error);
    this.setState({ error });
    console.log({ error, errorInfo });
  }
  render() {
    if (this.state.hasError) {
      return (
        <>
          <BrandAware>
            {({ brand }) => (
              <div className="flex flex-col min-h-full pt-16 pb-12 bg-white">
                <main className="flex flex-col justify-center flex-grow w-full px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                  <div className="flex justify-center flex-shrink-0">
                    <a href="/" className="inline-flex">
                      <span className="sr-only">Workflow</span>
                      {brand?.logo && (
                        <Image
                          width="300"
                          height="80"
                          priority
                          src={brand.logo?.downloadUrl}
                          alt={`${brand.name} Logo`}
                        />
                      )}
                    </a>
                  </div>
                  <div className="py-16">
                    <div className="text-center">
                      <p className="text-lg font-semibold tracking-wide text-indigo-600 uppercase">
                        Error
                      </p>
                      <p className="mt-8 text-base text-gray-500">
                        Sorry, we ran into an error. We&apos;ve been notified and will look into it.
                        <br /> If it happens again, please contact us at{' '}
                        <a
                          className="text-primary-pure-blue"
                          href="mailto:engineering@earlyday.com"
                        >
                          engineering@earlyday.com
                        </a>
                      </p>
                      <pre>
                        <code>{JSON.stringify(this.state.error, null, 2)}</code>
                      </pre>
                    </div>
                  </div>
                </main>
              </div>
            )}
          </BrandAware>
        </>
      );
    }

    return this.props.children;
  }
}

export default FullPageErrorBoundary;
